import { Table, Column, FieldType, FormatType, Section, Button } from "../../../../features/ui"
import { Badge } from "../../../../features/ui/components/badge/badge"
import { useDataTypesHooks } from "../../../../features/data-types"

type Props = {
    rows: { taxId: number; main: boolean }[]
    readOnly?: boolean
    onCreate?: () => void
    onEditRow?: (taxId: string) => void
    onRemoveRow?: (taxId: string) => void
}

export const TaxIdsTable = (props: Props) => {
    const { rows, readOnly, onCreate, onEditRow, onRemoveRow } = props

    const { formatCustomValue } = useDataTypesHooks()

    const columns: Column[] = [
        {
            name: 'taxId',
            type: FieldType.TEXT,
            label: 'CUIT',
            render: (value) => formatCustomValue(value, FormatType.CUIT_CUIL)
        },
        {
            name: 'main',
            type: FieldType.BOOLEAN,
            label: '',
            render: (value) => value ? (
                <Badge kind="secondary"  icon="check" label="Principal" />
            ) : ''
        }
    ]

    return (
        <Section id="taxIds" collapsable defaultExpanded>
            <Table
                columns={columns}
                rows={rows.map(r => ({ taxId: r.taxId, main: r.main }))}
                rowId="taxId"
                readOnly={readOnly}
                createIcon="plus"
                createLabel="Agregar CUIT"
                small
                onCreate={onCreate}
                onEdit={onEditRow}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}